
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.226 3.06a3.5 3.5 0 010 4.95L8.054 19.182a3 3 0 01-1.193.731l-2.916.949c-1.555.506-3.026-.966-2.52-2.52l.948-2.917a3 3 0 01.731-1.193L14.276 3.061a3.5 3.5 0 014.95 0zM15.69 4.476L4.52 15.646a1 1 0 00-.244.398l-.949 2.916 2.916-.949a1 1 0 00.398-.243L17.811 6.596a1.5 1.5 0 10-2.12-2.121zM10 21a1 1 0 100 2h11a1 1 0 100-2H10z"}})])
          )
        }
      }
    